import type { User } from '@auth0/auth0-react';

export enum UserRoles {
  'USER' = 'USER',
  'SPONSOR' = 'SPONSOR',
  'READER' = 'READER',
  'ADMIN' = 'ADMIN',
  'PROJECT_MANAGER' = 'PROJECT_MANAGER',
  'DATA_MANAGER' = 'DATA_MANAGER',
  'SITE' = 'SITE',
  'IMAGING_SPECIALIST' = 'IMAGING_SPECIALIST',
  'SUPPORT' = 'SUPPORT',
  'VALIDATION_SPECIALIST' = 'VALIDATION_SPECIALIST',
  'EXTERNAL_USER' = 'EXTERNAL_USER',
}

export type D7UserExtention = {
  'dynamika7/user_metadata': { roles: UserRoles[]; uuid: string };
  intercom: string;
  selectedRole: UserRoles | null;
};

export enum UserAffiliationType {
  SITE = 'SITE',
  CLINICAL_TRIAL = 'CLINICAL_TRIAL',
  SPONSOR = 'SPONSOR',
}

export type AuthUser = User & D7UserExtention;
